"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenFromRequest = void 0;
var errors_1 = require("@fleek-platform/errors");
var getTokenFromRequest = function (request) {
    var header = request.headers.authorization;
    if (!header) {
        throw new errors_1.AuthorizationError();
    }
    return header.replace('Bearer ', '');
};
exports.getTokenFromRequest = getTokenFromRequest;
